"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("./../../../shared/global-tokens");
var _FocusRing = require("../../../shared/utility-components/FocusRing");
var _jsxRuntime = require("react/jsx-runtime");
var StyledTrigger = _styledComponents.default.button.withConfig({
  displayName: "Trigger__StyledTrigger",
  componentId: "sc-6f8gmk-0"
})(["all:unset;box-sizing:border-box;display:flex;gap:", ";cursor:pointer;justify-content:left;align-items:center;padding-left:", ";height:", ";width:100%;"], _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['300'], _globalTokens.globalSizing['1100']);
var Trigger = function Trigger(_ref) {
  var children = _ref.children,
    expanded = _ref.expanded,
    onClick = _ref.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FocusRing.FocusRing, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTrigger, {
      onClick: onClick,
      "data-cy": "vertical-nav-toggle-state-btn",
      "aria-label": expanded ? 'Collapse menu' : 'Expand menu',
      children: children
    })
  });
};
var _default = exports.default = Trigger;